// src/services/swal.js
//
// Single source of truth for all SweetAlert2 styling and defaults.
// Import `swal` from this file everywhere — never import directly from sweetalert2.
// To change look-and-feel site-wide, edit only this file.

import Swal from "sweetalert2";

const swal = Swal.mixin({
  // ── App-wide visual styling hooks ─────────────────────────────────────────
  customClass: {
    popup: "app-swal-popup",
    title: "app-swal-title",
    htmlContainer: "app-swal-body",
    actions: "app-swal-actions",
    confirmButton: "app-swal-btn app-swal-btn-confirm",
    cancelButton: "app-swal-btn app-swal-btn-cancel",
    denyButton: "app-swal-btn app-swal-btn-deny",
  },
  buttonsStyling: false,
  backdrop: "rgba(1, 43, 74, 0.35)",

  // ── Behaviour defaults ────────────────────────────────────────────────────
  allowOutsideClick: true,
  allowEscapeKey: true,
  focusConfirm: true,
  confirmButtonColor: undefined,
  cancelButtonColor: undefined,
});

export default swal;
